import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DropDownFilterSettings } from "@progress/kendo-angular-dropdowns";
import { ActivitySetPlannedVisitDateModel } from "../../../models/activity-workflow/activity-set-planned-visit-date.model";
import { AppService } from "../../../../app.service";
import { ActivitiesService } from "../../../services/activities.service";
import { NotificationService } from "../../../../core/services/notification.service";
import { DialogRef, DialogService } from "@progress/kendo-angular-dialog";
import { ActivityPerformerSlotsConfirmationComponent } from "../activity-performer-slots-confirmation/activity-performer-slots-confirmation.component";
import { TransferInitiatorEnum } from "../../../enums";

@Component({
    selector: 'set-planned-visit-date',
    templateUrl: './set-planned-visit-date.component.html',
    styleUrls: ['./set-planned-visit-date.component.scss']
})
export class SetPlannedVisitDateComponent implements OnInit {

    @Input() planStartDate: Date;
    @Input() performerUserId: number;
    @Input() performerUserName: string;
    @Input() activityId: number;

    @Output() onContinueEvent: EventEmitter<ActivitySetPlannedVisitDateModel> = new EventEmitter<ActivitySetPlannedVisitDateModel>();
    @Output() onCancelEvent: EventEmitter<any> = new EventEmitter<any>();

    visitDateModel: ActivitySetPlannedVisitDateModel;
    readonly transferInitiatorEnum = TransferInitiatorEnum;

    constructor(
        private activitiesService: ActivitiesService,
        private appService: AppService,
        private notificationsService: NotificationService,
        private dialogService: DialogService
    ) { }

    ngOnInit(): void {
        this.visitDateModel = new ActivitySetPlannedVisitDateModel();
        this.visitDateModel.planStartDate = this.appService.parseDateTime(this.planStartDate);
    }
    
    public dropDownFilterSettings: DropDownFilterSettings = { caseSensitive: false, operator: 'contains' };

    cancel() {
		this.onCancelEvent.emit();
	}

	continue() {
        if (this.performerUserId == null ) {
            this.onContinueEvent.emit(this.visitDateModel);
        }
        else {
            this.activitiesService.checkActivityPerformerSlots(this.performerUserId, this.visitDateModel.planStartDate).subscribe(resp => {
                let otherActivitySlots = resp.data.filter(x => x.activityId != this.activityId);

                if (otherActivitySlots.length > 0) {
                    const dialogRef = this.dialogService.open({
                        title: `На это время у ${this.performerUserName} уже есть назначенные заявки`,
                        content: ActivityPerformerSlotsConfirmationComponent
                    });
        
                    const dialog = <ActivityPerformerSlotsConfirmationComponent>dialogRef.content.instance;
                    dialog.activityPerformerSlots = otherActivitySlots;
        
                    dialog.onCancelEvent.subscribe(() => {
                        dialogRef.close();
                    });
                    dialog.onContinueEvent.subscribe(() => {
                        this.onContinueEvent.emit(this.visitDateModel);
                        dialogRef.close();
                    });
                }
                else {
                    this.onContinueEvent.emit(this.visitDateModel);
                }
            });
        }
	}

    lessThenNow(date: Date): boolean {
        return date && date < new Date();
    }

    get formValid(): boolean {
        return this.visitDateModel.planStartDate
            && !this.lessThenNow(this.visitDateModel.planStartDate)
            && !!this.visitDateModel.transferInitiatorId;
    }
}